import { useState } from "react";
import Seo from "../components/SeoComponent/Seo";
import {
  GenerateMerchantToken,
  GetMerchantReport,
  GetUserDataByIdService,
} from "../services/apiService";
import { Copy, EyeIcon, Loader } from "lucide-react";
import { showErrorToast, showSuccessToast } from "../utils/toastUtils";
import { useEffect } from "react";

export default function MerchantTokenGenerator() {
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(null);
  const [reportData, setReportData] = useState([]);
  // const [input, setInput] = useState(null);
  const [userId, setUserId] = useState(null);
  const [inputError, setInputError] = useState(null);
  const [isCopied, setIsCopied] = useState({});
  const [openViewModal, setOpenViewModal] = useState(false);
  const [searchByUserId, setSearchByUserId] = useState(null);
  const [status, setStatus] = useState("SUCCESS");
  const [search, setSearch] = useState(null);
  const [perPage, setPerPage] = useState(10);
  const [webhookUrl, setWebhookUrl] = useState(null);
  const [pagination, setPagination] = useState(null);
  const [page, setPage] = useState(1);
  const [userDetails, setUserDetails] = useState(null);

  const [viewData, setViewData] = useState({
    label: "",
    id: "",
    userId: "",
    name: "",
    mobileNumber: "",
  });

  async function handleGenerateToken() {
    setLoading(true);

    if (!userId) {
      setInputError(" User Id is required");
    }

    try {
      const res = await GenerateMerchantToken(userId);

      if (res) {
        setResponse(res);
      }

      if (res?.status?.code === 200) {
        // showSuccessToast(res?.message);
      } else {
        showErrorToast("Invalid User Id");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  const handleMerchantReport = async () => {
    setLoading(true);

    const payload = {};

    if (searchByUserId) payload.user_id = searchByUserId;
    if (status) payload.status = status;
    if (search) payload.search = search;
    if (perPage) payload.per_page = perPage;
    if (webhookUrl) payload.webhook_url = webhookUrl;
    payload.page = page;

    try {
      const res = await GetMerchantReport(
        Object.keys(payload).length ? payload : undefined,
      );

      if (res?.data) {
        setReportData(res.data);
        setPagination(res?.pagination);

        setUserId(null);
      }

      if (res?.status?.code === 200) {
        setUserId(null);
      } else {
        showErrorToast(res?.data?.status?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      setUserId(null);
    }
  };

  const handleCopy = (text, index) => {
    navigator.clipboard.writeText(text);

    setIsCopied((prev) => ({
      ...prev,
      [index]: true,
    }));

    // reset after 2 seconds
    setTimeout(() => {
      setIsCopied((prev) => ({
        ...prev,
        [index]: false,
      }));
    }, 2000);
  };

  const handleViewClick = (key, id, userId, name, mobileNumber) => {
    setOpenViewModal((prev) => !prev);
    setViewData({ label: key, id, userId, name, mobileNumber });
  };

  useEffect(() => {
    console.log("report Data ***************************************");
    console.log(reportData);
  }, [reportData]);

  useEffect(() => {
    handleMerchantReport();
  }, [page]);

  useEffect(() => {
    const getUserdetails = async () => {
      const res = await GetUserDataByIdService({ userId });

      console.log(res);

      setUserDetails(res);
    };
    if (userId?.length === 8) {
      getUserdetails();
    }
  }, [userId]);

  return (
    <>
      <Seo />

      <div className="w-full pt-5 px-4 min-h-screen bg-white flex flex-col items-center overflow-hidden gap-4 p-6 rounded-lg shadow-sm border">
        <h2 className="text-xl font-semibold mb-4">Merchant Token Generator</h2>

        <div className="flex gap-2 items-center justify-center">
          <label htmlFor="userId" className="font-bold text-xl">
            {" "}
            User Id <span className="text-xl font-bold text-red-700">*</span>
          </label>
          <input
            type="text"
            value={userId}
            onChange={(e) => setUserId(e.target.value.toUpperCase())}
            placeholder="Enter User Id"
            maxLength={10}
            className="
    px-4 py-2
    text-sm text-gray-900
    bg-white
    border border-gray-300
    rounded-md
    outline-none
    transition
    focus:border-black
    focus:ring-1
    focus:ring-black
    placeholder-gray-400 uppercase
  "
          />
        </div>

        {loading && (
          <div>
            <Loader className="animate-spin" />
          </div>
        )}
        <button
          disabled={!userId}
          onClick={handleGenerateToken}
          className="bg-gradient-to-br from-purple-700 to-blue-700 text-white px-5 py-2 rounded-md hover:bg-gray-800 disabled:opacity-70 disabled:cursor-not-allowed"
        >
          Generate Merchant Token
        </button>

        {/* generated token details */}

        {userDetails && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 bg-blue-100 p-4 rounded-md border border-blue-600">
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Name</span>
              <span className="font-medium">
                {userDetails.user?.name || "-"}
              </span>
            </div>

            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Mobile</span>
              <span className="font-medium">
                {userDetails.user?.mobile_number || "-"}
              </span>
            </div>

            <div className="flex justify-between text-sm">
              <span className="text-gray-500 mr-2">Email </span>
              <span className="font-medium">
                {userDetails.user?.email_address || "-"}
              </span>
            </div>

            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Company</span>
              <span className="font-medium">
                {userDetails.company?.name || "Individual"}
              </span>
            </div>
          </div>
        )}

        {response?.data && (
          <div className="w-full max-w-2xl mt-4 rounded-xl border border-green-200 bg-green-50 p-5 shadow-sm">
            <p className="text-lg font-semibold text-green-700 mb-4">
              {response.data?.message}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3 text-sm">
              <div className="flex justify-between gap-2">
                <span className="font-medium text-gray-600">ID</span>
                <span className="text-gray-900">
                  {response?.data?.data?.id}
                </span>
              </div>

              <div className="flex justify-between gap-2">
                <span className="font-medium text-gray-600">User ID</span>
                <span className="text-gray-900">
                  {response?.data?.data?.user_id}
                </span>
              </div>

              <div className="flex justify-between gap-2">
                <span className="font-medium text-gray-600">Device ID</span>
                <span className="text-gray-900">
                  {response?.data?.data?.device_id || "-"}
                </span>
              </div>

              <div className="flex justify-between gap-2">
                <span className="font-medium text-gray-600">Enterprise ID</span>
                <span className="text-gray-900 truncate max-w-[180px]">
                  {response?.data?.data?.enterprise_id || "-"}
                </span>
              </div>

              <div className="flex justify-between gap-2">
                <span className="font-medium text-gray-600">Subject ID</span>
                <span className="text-gray-900">
                  {response?.data?.data?.subject_id}
                </span>
              </div>

              <div className="flex justify-between gap-2">
                <span className="font-medium text-gray-600">Subject Type</span>
                <span className="text-gray-900">
                  {response?.data?.data?.subject_type}
                </span>
              </div>

              <div className="flex justify-between gap-2">
                <span className="font-medium text-gray-600">Status</span>
                <span
                  className={`px-2 py-1 rounded-full text-xs font-semibold
            ${
              response?.data?.data?.status === "SUCCESS"
                ? "bg-green-100 text-green-700"
                : "bg-red-100 text-red-700"
            }`}
                >
                  {response?.data?.data?.status}
                </span>
              </div>
            </div>
          </div>
        )}

        {/* search and filter fields */}

        <div className="bg-white rounded-xl shadow-sm p-4">
          <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-5 gap-4">
            {/* Search */}
            <div className="flex flex-col gap-1">
              <label className="text-xs font-medium text-gray-600">
                Search
              </label>
              <input
                type="search"
                placeholder="Search..."
                onChange={(e) => setSearch(e.target.value)}
                className="px-3 py-2  border-gray-800 text-sm border  rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* User ID */}
            <div className="flex flex-col gap-1">
              <label className="text-xs font-medium text-gray-600">
                User ID
              </label>
              <input
                type="text"
                value={searchByUserId}
                onChange={(e) =>
                  setSearchByUserId(e.target.value.toUpperCase())
                }
                placeholder="Enter User ID"
                className="px-3 py-2 text-sm border border-gray-800 uppercase rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* Status Filter */}
            <div className="flex flex-col gap-1">
              <label className="text-xs font-medium text-gray-600">
                Status
              </label>
              <select
                onChange={(e) => setStatus(e.target.value)}
                className="px-3 py-2 text-sm border border-gray-800 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="SUCCESS">SUCCESS</option>
                <option value="FAILED">FAILED</option>
              </select>
            </div>

            {/* Per Page */}
            <div className="flex flex-col gap-1">
              <label className="text-xs font-medium text-gray-600">
                Per Page
              </label>
              <select
                onChange={(e) => setPerPage(e.target.value)}
                className="px-3 py-2 text-sm border border-gray-800 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>

            {/* Search */}
            <div className="flex flex-col gap-1">
              <label className="text-xs font-medium text-gray-600">
                Webhook url
              </label>
              <input
                type="search"
                placeholder="Webhook url"
                onChange={(e) => setWebhookUrl(e.target.value)}
                className="px-3 py-2  border-gray-800 text-sm border  rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>
        </div>

        <button
          onClick={handleMerchantReport}
          className="bg-gradient-to-br from-purple-700 to-blue-700 text-white px-5 py-2 rounded-md hover:bg-gray-800 disabled:opacity-70 disabled:cursor-not-allowed"
        >
          Get Report
        </button>

        {/* table layout*/}

        {reportData.length > 0 && (
          <div className="w-full px-3 md:px-6">
            <div className="mt-6 w-full overflow-x-auto rounded-xl border border-gray-200 shadow-sm">
              <table className="min-w-[700px] w-full text-xs text-left text-gray-700">
                <thead className="bg-gray-100 text-gray-600 uppercase tracking-wider sticky top-0 z-10">
                  <tr>
                    <th className="px-4 py-3">ID</th>
                    <th className="px-4 py-3">User ID</th>
                    <th className="px-4 py-3">Device ID</th>
                    <th className="px-4 py-3">Enterprise ID</th>
                    <th className="px-4 py-3">Subject</th>
                    <th className="px-4 py-3">Type</th>
                    <th className="px-4 py-3">Method</th>
                    <th className="px-4 py-3">Use Case</th>
                    <th className="px-4 py-3">Status</th>
                    <th className="px-4 py-3 ">Token </th>
                    <th className="px-4 py-3">Created At</th>
                  </tr>
                </thead>

                <tbody className="divide-y divide-gray-100 bg-white">
                  {reportData?.map((item, index) => (
                    <tr
                      key={item.user_id}
                      className={`hover:bg-gray-50 ${
                        index % 2 === 0 ? "bg-white" : "bg-gray-50/50"
                      }`}
                    >
                      <td className="px-4 py-3 font-medium">{item.user_id}</td>
                      <td className="px-4 py-3  flex items-center gap-2">
                        {item.user?.user_id}
                        <button
                          className={` rounded-full px-2 flex items-center gap-2 py-1${
                            openViewModal
                              ? "bg-green-100 text-green-700"
                              : "bg-red-100 text-yellow-700"
                          }`}
                          type="button"
                          onClick={() =>
                            handleViewClick(
                              "user",
                              item.user_id,
                              item.user?.user_id,
                              item.user?.name,
                              item.mobile_number,
                            )
                          }
                        >
                          <EyeIcon />
                        </button>{" "}
                      </td>
                      <td className="px-4 py-3">{item.device_id}</td>

                      <td className="px-4 py-3 max-w-[220px] truncate">
                        {item.enterprise_id}
                      </td>

                      <td className="px-4 py-3">{item.subject_id}</td>
                      <td className="px-4 py-3">{item.subject_type}</td>
                      <td className="px-4 py-3">{item.method}</td>
                      <td className="px-4 py-3">{item.use_case}</td>

                      <td className="px-4 py-3">
                        <span
                          className={`px-2 py-1 rounded-full text-[10px] font-semibold
                ${
                  item.status === "SUCCESS"
                    ? "bg-green-100 text-green-700"
                    : "bg-red-100 text-red-700"
                }`}
                        >
                          {item.status}
                        </span>
                      </td>

                      <td
                        className={`px-4 py-3 flex items-center gap-2 cursor-pointer  `}
                        title={item.token}
                      >
                        {item.token?.split("").slice(0, 10).join("")}{" "}
                        <button
                          className={` rounded-full px-2  py-1${
                            isCopied
                              ? "bg-green-100 text-green-700"
                              : "bg-red-100 text-yellow-700"
                          }`}
                          type="button"
                          onClick={() => handleCopy(item.token, index)}
                        >
                          {isCopied[index] ? "Copied" : <Copy />}
                        </button>
                      </td>

                      <td className="px-4 py-3 whitespace-nowrap">
                        {new Date(item.created_at).toLocaleString()}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {pagination && (
          <div className="flex items-center justify-between mt-4 px-2 text-sm text-gray-600">
            <span>
              Page {pagination.current_page} of {pagination.last_page}
            </span>

            <div className="flex gap-2">
              <button
                disabled={!pagination.prev_page_url}
                onClick={() => setPage((p) => p - 1)}
                className="px-3 py-1 rounded border disabled:opacity-40"
              >
                Prev
              </button>

              <button
                disabled={!pagination.next_page_url}
                onClick={() => setPage((p) => p + 1)}
                className="px-3 py-1 rounded border disabled:opacity-40"
              >
                Next
              </button>
            </div>
          </div>
        )}

        {openViewModal && (
          <ViewModal
            label={viewData.label}
            id={viewData.id}
            userId={viewData.userId}
            name={viewData.name}
            mobileNumber={viewData.mobileNumber}
            onClose={() => setOpenViewModal(false)}
          />
        )}
      </div>
    </>
  );
}

const ViewModal = ({ label, id, userId, name, mobileNumber, onClose }) => {
  return (
    <div className="fixed inset-0 z-30 flex items-center justify-center ">
      <div
        onClick={onClose}
        className="w-full h-full bg-black/50 z-40 absolute top-0 left-0 "
      ></div>
      <div className="bg-green-100 px-12  z-50  p-8 rounded-lg text-green-600 flex items-center justify-center">
        <div>
          <p className="text-2xl font-bold capitalize mb-4">{label} Details</p>

          <p>Id: {id}</p>
          <p>UserId: {userId}</p>
          <p>name: {name}</p>
          <p>Mobile: {mobileNumber}</p>
        </div>
      </div>
    </div>
  );
};
